import { IncidentCsvHeaders } from 'src/api/types/misc';
import _ from 'lodash';
import { IncidentCSV } from './types';

export const generateCsvTemplateLink = () => {
  const csvString = Object.values(IncidentCsvHeaders).join(',') + '\n';

  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  return URL.createObjectURL(blob);
};

export const pathNames = {
  id: IncidentCsvHeaders.ID,
  ref: IncidentCsvHeaders.RefID,
  name: IncidentCsvHeaders.Name,
  description: IncidentCsvHeaders.Description,
  source: IncidentCsvHeaders.Source,
  dateOfIncident: IncidentCsvHeaders.Date,
  owner: IncidentCsvHeaders.Owner,
  impact: IncidentCsvHeaders.Impact,
  financialImpactUpper: IncidentCsvHeaders.FinancialImpactUpper,
  financialImpactLower: IncidentCsvHeaders.FinancialImpactLower,
  incidentType: IncidentCsvHeaders.Type,
  severity: IncidentCsvHeaders.Severity,
};

export const isValidHeaders = (data: IncidentCSV) => {
  const expectedHeaders = Object.values(IncidentCsvHeaders).map(String);
  const parsedHeaders = Object.keys(data);

  const missingElements = _.difference(expectedHeaders, parsedHeaders);

  return missingElements.length === 0;
};
